var _                         = require('underscore');
var $                         = require('jquery');
var Core                      = require('../core/core.js');
var DashboardListComponentsItem = require('./dashboard__listcomponents__item.js');

/**
 * Creates an overlay tray large components
 *
 * @class
 */

class DashboardListComponents extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__dashboard__listcomponents js-editor__dashboard__listcomponents">
              <h2 class="editor__dashboard__listcomponents__title js-editor__dashboard__listcomponents__title"></h2>
              <div class="editor__dashboard__listcomponents__content js-editor__dashboard__listcomponents__content"></div>
              <div class="editor__dashboard__listcomponents__seeMoreBtn__container">
                <a href="">
                  <div class="editor__dashboard__listcomponents__seeMoreBtn js-editor__dashboard__listcomponents__seeMoreBtn">
                    See More...
                  </div>
                </a>
              </div>
            </div>
        `;

        super.render();

    }

    setTitle(title) {
      $('.js-editor__dashboard__listcomponents__title', this.$el).text(title);
    }

    /**
     * @event TrayTabListComponents#Cioui:TrayTabItem:clicked
     * @property {String}Cioui:TrayTabSort:clicked
     * @returns {String} sort key
     */

    _itemClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:Sort:clicked', $(e.currentTarget).data('sortkey'));
    }

    /*
     * Add an item to the tray content list
     * @param dataObj - json object
     * @param dataObj.name
     * @param dataObj.description
     * @param dataObj.updated_at
     * @param dataObj.thumb_url
     * @param dataObj.document_id
    */

    addItem(dataObj){
        var convertedTime = new Date(dataObj["updated_at"]);
        var displayDate = convertedTime.getMonth() + "/" + convertedTime.getDate() + "/" + convertedTime.getFullYear();
        var timeDifference = Math.floor((Date.now() - convertedTime)/1000/60);
        return new DashboardListComponentsItem({
            target: $('.js-editor__dashboard__listcomponents__content',this.$el),
            fields: {
                "name": dataObj["name"],
                "description": dataObj["description"],
                "updated_at": {"displayDate": displayDate, "timeDifference": timeDifference},
                "thumb_url": dataObj["thumb_url"],
                "document_id": dataObj["document_id"],
            }
        });
    }


}
module.exports = DashboardListComponents;
